import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbUserPermissionApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'db-userpermission';
    }

    public async getListByUser() {
        return await this.send({}, 'getListByUser', Methods.GET);
    }

    public async getListByUserId(userId) {
        return await this.send({userId}, 'getListByUserId', Methods.GET);
    }

    public async dbUserpermissionSaveOrUpdate(datas) {
        return await this.send(datas, 'dbUserpermissionSaveOrUpdate', Methods.POST);
    }

}